// extracted by mini-css-extract-plugin
module.exports = {"description":"NoteStyle_description__i_kI8"};